import { Link } from 'react-router-dom';
import { articles } from '@/mocks/site';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.isFeatured).slice(0, 3);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
          头条爆料
        </h2>
        <span className="w-12 h-0.5 bg-primary-500 flex-1 ml-4 hidden sm:block"></span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {featured.map((article, index) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className={`group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer ${
              index === 0 ? 'md:col-span-2 md:row-span-2' : ''
            }`}
          >
            <div className={`relative overflow-hidden ${index === 0 ? 'h-64 md:h-full' : 'h-48'}`}>
              <img
                src={article.image}
                alt={article.title}
                title={`${article.title} - 黑料吃瓜网`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                  {article.tags[0]}
                </span>
              </div>
              {article.isHot && (
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 text-xs font-bold bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    HOT
                  </span>
                </div>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3
                  className={`font-bold font-heading text-white leading-snug line-clamp-2 ${
                    index === 0 ? 'text-lg md:text-xl' : 'text-sm md:text-base'
                  }`}
                >
                  {article.title}
                </h3>
                {index === 0 && (
                  <p className="text-white/70 text-sm mt-2 line-clamp-2 hidden md:block">
                    {article.excerpt}
                  </p>
                )}
                <div className="flex items-center gap-3 mt-3 text-white/60 text-xs">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-message-3-line"></i>
                    {article.comments}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}